/**
 * Directive that constantly fires an event every 50 milliseconds when the mouse is clicked
 * until it is released
 */
const clickHold = {

  /**
   * This is called when the directive is bound to the element
   *
   * @param {object} el       The element we are binding to
   * @param {object} binding  Binding details
   */
  bind: ( el, binding ) => {
    // Holds a reference to the current mouse down interval
    let mouseDownInterval = null;

    /**
     * Execute what ever has been passed to the directive
     */
    const handler = ( eventArgs ) => {
      binding.value( eventArgs );
    };

    /**
     * Event fired when the scrolling is started
     *
     * @param {object} eventArgs The event arguments
     */
    const start = ( eventArgs ) => {
      if ( ( eventArgs.type === "mousedown" && eventArgs.button === 0 )
            || eventArgs.type === "touchstart" ) {
        if ( mouseDownInterval ) {
          // Clear any previous intervals
          clearInterval( mouseDownInterval );
        }

        // Call the hanlder every 50 milliseconds
        mouseDownInterval = setInterval( handler, 50 );
      }

      eventArgs.preventDefault();
    };

    /**
     * Event fired when the scrolling is cancelled
     */
    const cancel = () => {
      if ( mouseDownInterval ) {
        clearInterval( mouseDownInterval );
        mouseDownInterval = null;
      }
    };

    // Add event listeners to the element
    el.addEventListener( "mousedown", start );
    el.addEventListener( "touchstart", start );
    el.addEventListener( "touchend", cancel );
    el.addEventListener( "click", cancel );
    el.addEventListener( "mouseout", cancel );

    // Save the events on the element so we can get at them from the "unbind" method
    // clean them up
    // eslint-disable-next-line no-param-reassign
    el.startEvent = start;
    // eslint-disable-next-line no-param-reassign
    el.cancelEvent = cancel;
  },

  /**
   * This is called when the directive is removed from the element
   *
   * @param {object} el The element we are unbinding from
   */
  unbind: ( el ) => {
    el.removeEventListener( "mousedown", el.startEvent );
    el.addEventListener( "touchstart", el.startEvent );
    el.addEventListener( "touchend", el.cancelEvent );
    el.removeEventListener( "click", el.cancelEvent );
    el.removeEventListener( "mouseout", el.cancelEvent );
  },
};

export default clickHold;
